import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/memberCoupon/page', data, {
    trim: true
  })
}
export function exportExcel (data) {
  return request.post('/business/memberCoupon/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/memberCoupon/addBatch', data)
}
